/**
 *
 * @Info
 * As a rule of thumb we name the exported getter
 * in CamelCaseCaps and the actual getter value in camelCase.
 */

// AUTH STORE GETTERS
export const GetUserData = 'getUserData';
export const GetOrganizationId = 'getOrganizationId';
export const GetActiveOrganization = 'getActiveOrganization';
export const GetActiveOrganizationRole = 'getActiveOrganizationRole';
export const GetLastOrganizationId = 'getLastOrganizationId';
export const GetOrganizations = 'getOrganizations';
export const GetOrganizationById = 'getOrganizationById';
export const HasUnlimitedAccess = 'hasUnlimitedAccess';
export const GetActiveSubscription = 'getActiveSubscription';
export const GetActiveSubscriptionPlan = 'getActiveSubscriptionPlan';
export const GetIsCrmConfigured = 'getIsCrmConfigured';
export const GetIsCrmAllowed = 'getIsCrmAllowed';

// AMP STORE GETTERS
export const GetStorageKeyValues = 'getStorageKeyValues';
export const GetCreateAmpDto = 'getCreateAmpDto';
export const GetCurrentAmp = 'getCurrentAmp';
export const GetCurrentConversations = 'getCurrentConversations';
export const GetCurrentConversation = 'getCurrentConversation';
export const GetSelectedConversationNodes = 'getSelectedConversationNodes';
export const GetSelectedConversationNodesArray = 'getSelectedConversationNodesArray';
export const GetSelectedConversationName = 'getSelectedConversation';
export const GetConversationById = 'getConversationById';
export const GetConversationNodesById = 'getConversationNodesById';
export const GetCurrentConversationEdges = 'getCurrentConversationEdges';
export const GetConversationEdgesById = 'getConversationEdgesById';
export const GetCurrentConversationsList = 'getCurrentConversationsList';
export const GetConversationsList = 'getConversationsList';
export const GetSelectedConversationIndex = 'getSelectedConversationIndex';
export const GetSelectedSubconversations = 'getSelectedSubconversations';
export const GetChildNodesByParentId = 'getChildNodesByParentId';
export const GetSelectedConversationTriggers = 'getSelectedConversationTriggers';
export const GetAmpStorage = 'getAmpStorage';
export const GetStorageEntries = 'getStorageEntries';
export const GetCurrentDeployments = 'getCurrentDeployments';
export const GetTriggers = 'getTriggers';
export const GetNextConversationSortIndex = 'getNextSortIndex';
export const GetNextLinkSortIndex = 'getNextLinkSortIndex';
export const GetAmpData = 'getAmpData';
export const GetAmpSortOrder = 'getAmpSortOrder';

// BUILDER STORE GETTERS
export const GetAddingNode = 'getAddingNode';
export const GetDragging = 'getDragging';
export const GetNodeById = 'getNodeById';
export const GetFirstNode = 'getFirstNode';
export const GetConnectedEdges = 'getConnectedEdges';
export const GetSelectedNodeId = 'getSelectedNodeId';
export const GetSelectedSubNode = 'getSelectedSubNode';
export const GetZoom = 'getZoom';
export const CanUndo = 'canUndo';
export const CanRedo = 'canRedo';
export const GetUndoChangeset = 'getUndoChangeset';
export const GetRedoChangeset = 'getRedoChangeset';
export const GetApplyChangesState = 'getApplyChangesState';

// SIDE PANEL GETTERS
export const SidepanelOpened = 'sidepanelOpened';

// PREVIEW GETTERS
export const GetStack = 'getStack';
export const GetCurrentNodeId = 'getCurrentNodeId';
export const GetCurrentConversationId = 'getCurrentConversationId';

// POPUP STORE GETTERS
export const GetConfigureMenuPopupState = 'getConfigureMenuPopupState';
export const GetMediaUploadPopupState = 'getMediaUploadPopupState';
export const GetSelectedNode = 'getSelectedNode';
export const GetDeleteConversationPopupState = 'getDeleteConversationPopupState';
export const GetSettingsPopupState = 'getSettingsPopupState';
export const GetDeletedConversationId = 'getDeletedConversationId';

// PLUGIN STORE GETTERS
export const GetPlugins = 'getPlugins';

// REALTIME GETTERS
export const GetRealtimeListener = 'retrieveRealtimeListener';

// WIZARD
export const GetAdditionalStepInfo = 'getStepAdditionalInfo';
export const GetUploadProgress = 'getUploadProgress';
export const GetZipFile = 'getZipFile';

// NOTIFICATIONS
export const GetNotifications = 'getNotifications';

// INSIGHTS
export const GetDateRanges = 'getDateRanges';
export const GetCurrentDateRange = 'GetCurrentDateRange';
export const GetAvailableTimeRanges = 'getAvailableTimeRanges';
export const GetInsightsUrlQueryParams = 'getInsightsUrlQueryParams';
export const GetResponseInsights = 'getResponseInsights';
export const GetSessionsWithTrends = 'getSessionsWithTrends';
export const GetDataInterval = 'getDataInterval';
export const GetDataByLabels = 'getDataByLabels';
export const GetTimeRangeLabels = 'getTimeRangeLabels';

// CRM
export const GetAvailableAccountKeys = 'getAvailableAccountKeys';
